import React from "react";

const SmartPagination = ({
    currentPage,
    totalPages,
    totalItems,
    pageSize,
    onPageChange,
}) => {
    if (totalPages <= 1) return null;
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalItems);
    const pages = [];
    if (currentPage > 1) pages.push(currentPage - 1);
    pages.push(currentPage);
    if (currentPage < totalPages) pages.push(currentPage + 1);

    return (
        <div className="mt-6">
            <div className="mb-4 flex items-center justify-between">
                <p className="text-sm text-gray-500">
                    Showing{" "}
                    <span className="font-semibold text-gray-700">
                        {start}
                    </span>{" "}
                    -{" "}
                    <span className="font-semibold text-gray-700">
                        {end}
                    </span>{" "}
                    of{" "}
                    <span className="font-semibold text-gray-700">
                        {totalItems}
                    </span>{" "}
                    campaigns
                </p>
            </div>

            <div className="flex items-center justify-center gap-2">
                <button
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                    className="rounded-lg border bg-white px-4 py-2 disabled:opacity-40"
                >
                    Previous
                </button>

                {currentPage > 2 && (
                    <>
                        <button
                            onClick={() => onPageChange(1)}
                            className="rounded border px-3 py-2"
                        >
                            1
                        </button>
                        <span>...</span>
                    </>
                )}

                {pages.map((page) => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`rounded border px-3 py-2 transition ${
                            page === currentPage
                                ? "border-indigo-600 bg-indigo-600 text-white"
                                : "bg-white hover:bg-gray-100"
                        }`}
                    >
                        {page}
                    </button>
                ))}

                {currentPage < totalPages - 1 && (
                    <>
                        <span>...</span>
                        <button
                            onClick={() => onPageChange(totalPages)}
                            className="rounded border px-3 py-2"
                        >
                            {totalPages}
                        </button>
                    </>
                )}
                <button
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                    className="rounded-lg border bg-white px-4 py-2 disabled:opacity-40"
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default SmartPagination;